import React from 'react';
import { Copy, VolumeUp, VolumeMute, HandThumbsUp, HandThumbsDown } from 'react-bootstrap-icons';

interface MessageActionsProps {
  content: string;
  messageId: string;
  onCopy: (content: string) => void;
  onReadAloud: (content: string) => void;
  onThumbsUp: (messageId: string) => void;
  onThumbsDown: (messageId: string) => void;
  iconSize?: number;
  isPlaying?: boolean;
  isRated?: boolean;
}

const MessageActions: React.FC<MessageActionsProps> = ({
  content,
  messageId,
  onCopy,
  onReadAloud,
  onThumbsUp,
  onThumbsDown,
  iconSize = 16,
  isPlaying = false,
  isRated = false
}) => {
  return (
    <>
      <div className="message-actions">
        <button className="message-action-btn" onClick={() => onCopy(content)} title="Copy">
          <Copy size={iconSize} />
        </button>
        <button
          className="message-action-btn"
          onClick={() => onReadAloud(content)}
          title={isPlaying ? "Stop reading" : "Read aloud"}
        >
          {isPlaying ? (
            <VolumeMute size={iconSize + 4} />
          ) : (
            <VolumeUp size={iconSize + 4} />
          )}
        </button>
        <button
          className="message-action-btn"
          onClick={() => onThumbsUp(messageId)}
          title="Good response"
          disabled={isRated}
          style={{ opacity: isRated ? 0.5 : 1, cursor: isRated ? 'not-allowed' : 'pointer' }}
        >
          <HandThumbsUp size={iconSize} />
        </button>
        <button
          className="message-action-btn"
          onClick={() => onThumbsDown(messageId)}
          title="Bad response"
          disabled={isRated}
          style={{ opacity: isRated ? 0.5 : 1, cursor: isRated ? 'not-allowed' : 'pointer' }}
        >
          <HandThumbsDown size={iconSize} />
        </button>
      </div>
      <div className="message-disclaimer">
        Great insights take iteration. If this isn't quite right, try reprompting or refining.
      </div>
    </>
  );
};

export default MessageActions;
